// EmailJourney.jsx — per-contact email funnel for a brand (or all): contacts →
// subscribed → enrolled → completed, plus the branch outcomes (unsub / bounce)
// and CRM-state movement the analyzer drives. Reads /api/admin/flows/email-journey.

import React, { useCallback, useEffect, useState } from "react";
import { get } from "../../api";

export default function EmailJourney({ brandId }) {
  const [j, setJ] = useState(null);
  const load = useCallback(async () => {
    try { const qs = brandId ? `?brandId=${encodeURIComponent(brandId)}` : ""; const r = await get(`/api/admin/flows/email-journey${qs}`); setJ((r && r.journey) || null); } catch (e) { /* */ }
  }, [brandId]);
  useEffect(() => { load(); const id = setInterval(load, 10000); return () => clearInterval(id); }, [load]);
  if (!j) return null;

  const node = (label, val, color) => (
    <div style={{ minWidth: 92, border: "1px solid #e5e7eb", borderRadius: 8, padding: "8px 10px", textAlign: "center", background: "#fff" }}>
      <div style={{ fontSize: 18, fontWeight: 700, color: color || "#111827" }}>{val}</div>
      <div style={{ fontSize: 11, color: "#666" }}>{label}</div>
    </div>
  );
  const arrow = <div style={{ display: "flex", alignItems: "center", color: "#c4c9d0", padding: "0 4px" }}>→</div>;

  return (
    <div style={{ marginTop: 16 }}>
      <div style={{ fontSize: 12, fontWeight: 700, color: "#198038", marginBottom: 6 }}>Email contact journey</div>
      <div style={{ display: "flex", alignItems: "stretch", flexWrap: "wrap", marginBottom: 8 }}>
        {node("Contacts", j.contacts)}{arrow}
        {node("Subscribed", j.subscribed, "#198038")}{arrow}
        {node("In sequence", j.sequences.active, "#0F62FE")}{arrow}
        {node("Completed", j.sequences.completed, "#198038")}
        <div style={{ width: 16 }} />
        {node("Unsubscribed", j.unsubscribed, "#d97706")}
        {node("Bounced/blocked", j.bounced, "#a71d2a")}
        {node("Stopped", j.sequences.stopped, "#888")}
      </div>
      <div style={{ fontSize: 11, color: "#666", marginBottom: 4 }}>Branched to CRM state (analyzer moves contacts on open / unsub / block):</div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
        {node("Engaged", j.byState.engaged)}
        {node("Qualified", j.byState.qualified)}
        {node("Customer", j.byState.customer, "#198038")}
        {node("Churned", j.byState.churned, "#a71d2a")}
      </div>
    </div>
  );
}
